import {userConstants} from '../constants'

export const userActions = {
    login,
    logout,
    loginSuccess,
    loginFailure,
    loginCheck,
    isLoggedIn,
    tokenrefresh,
    getUserProfileRequest,
    getUserProfileSuccess,
    getUserProfileFailure,
}

function login(credentials) {
    return {type: userConstants.LOGIN_REQUEST, credentials}
}

function tokenrefresh(token, noalertmsg) {
    return {type: userConstants.LOGIN_REFRESH, token, noalertmsg}
}

function logout(message) {
    return {type: userConstants.LOGOUT, message}
}

function loginSuccess(
    token,
    displayname,
    firstname,
    lastname,
    euid,
    emplid,
    exp
) {
    return {
        type: userConstants.LOGIN_SUCCESS,
        token,
        displayname,
        firstname,
        lastname,
        euid,
        emplid,
        exp,
    }
}

function loginFailure(message) {
    return {type: userConstants.LOGIN_FAILURE, message}
}

function loginCheck(loggedin) {
    return {type: userConstants.LOGIN_CHECK, loggedin}
}

function isLoggedIn() {
    return {type: userConstants.LOGIN_ACTIVE}
}

/********* GET Loggedin User profile Actions  *********************************/
function getUserProfileRequest(token) {
    return {type: userConstants.LOGIN_GETUSERPROFILE_REQUEST, token}
}

function getUserProfileSuccess(data) {
    return {type: userConstants.LOGIN_GETUSERPROFILE_SUCCESS, data}
}

function getUserProfileFailure(message) {
    return {type: userConstants.LOGIN_GETUSERPROFILE_FAILURE, message}
}
